module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_Termin buchen.02a2bf8e.jpg";